import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { push as pushAction } from 'react-router-redux';
import {
	isEqual, map, forEach, isEmpty, get,
} from 'lodash';
import utils from '@utils';
import { SubNavBar } from '@components/common';
import { thunks } from '@redux/payments';
import queryString from 'query-string';
import { PaymentReceiptTable } from './components';

class PaymentReceipt extends Component {
	constructor(props) {
		super(props);
		const TimeZoneId = get(this.props, ['TimeZoneId'], 'America/Chicago');
		this.state = {
			data          : this.getFormattedData(props.receipt),
			totalReceipt  : props.receipt.TotalReceipt,
			paidOn        : !isEmpty(props.receipt) ? utils.parseUTCDateToTimeZone(props.receipt.PaymentDate, TimeZoneId).format('MM/DD/YYYY') : '',
			transactionId : !isEmpty(props.receipt) ? props.receipt.TransactionId : '',
		};
	}

	componentDidMount() {
		const { getReceiptDetails, match : { params : { id } } } = this.props;
		getReceiptDetails(id);
	}

	UNSAFE_componentWillReceiveProps = ({ receipt, TimeZoneId }) => {
		const lastProps = this.props;

		if (!isEqual(receipt, lastProps.receipt)) {
			this.setState({
				data          : this.getFormattedData(receipt),
				totalReceipt  : receipt.TotalReceipt,
				paidOn        : utils.parseUTCDateToTimeZone(receipt.PaymentDate, TimeZoneId).format('MM/DD/YYYY'),
				transactionId : receipt.TransactionId,
			});
		}
	};

	shouldComponentUpdate = ({ receipt, loading }, { data, transactionId, paidOn }) => {
		const lastProps = this.props;
		const lastState = this.state;
		return (
			!isEqual(lastState.data, data)
			|| !isEqual(lastState.transactionId, transactionId)
			|| !isEqual(lastState.paidOn, paidOn)
			|| !isEqual(lastProps.receipt, receipt)
			|| !isEqual(lastProps.loading, loading)
		);
	};

	getFormattedData = (rawData) => {
		const {
			TransactionSummaryItems,
			TotalOfficerPay,
			TotalOrganizationFee,
			RKPayFee,
			Tax,
			Total,
			Organizations,
			TotalJurisdictionFee,
		} = rawData;
		let returnData = [];
		if (TransactionSummaryItems && TransactionSummaryItems.length) {
			returnData = map(TransactionSummaryItems, (officerItem, index) => {
				const TimeZoneId = get(this.props, ['TimeZoneId'], 'America/Chicago');
				return {
					rowId   : `officer_${index}`,
					invoice : {
						id       : officerItem.InvoiceId,
						statusId : officerItem.InvoiceStatusId,
					},
					dateTime : {
						date      : utils.parseUTCDateToTimeZone(officerItem.StartDateTime, TimeZoneId).format('ddd, MMM D, YYYY'),
						startTime : utils.parseUTCDateToTimeZone(officerItem.StartDateTime, TimeZoneId).format('h:mm A'),
						endTime   : utils.parseUTCDateToTimeZone(officerItem.EndDateTime, TimeZoneId).format('h:mm A'),
					},
					location    : officerItem.Location,
					officername : {
						name  : officerItem.Officer || '',
						image : officerItem.OfficerPhotoUrl || '',
					},
					hours     : officerItem.Hours,
					rate      : officerItem.Rate,
					amountDue : officerItem.Amount,
				};
			});
			returnData.push({
				rowId     : 'TotalOfficerPay',
				type      : 'total',
				label     : 'Total Officers Pay',
				amountDue : TotalOfficerPay,
			});
			if (Organizations && Organizations.length) {
				forEach(Organizations, (item, index) => {
					returnData.push({
						rowId            : `coordinator${index}`,
						type             : 'coordinator',
						firstCoordinator : !index,
						officername      : {
							name  : item.Name,
							image : item.ProfilePhotoURL,
						},
						hours     : item.Hours,
						rate      : item.Rate,
						amountDue : item.Amount,
					});
				});
				returnData.push({
					rowId     : 'TotalCoordinatorFee',
					type      : 'total',
					label     : 'Total Coordinators Fees',
					amountDue : TotalOrganizationFee,
				});
			}
			returnData.push({
				rowId     : 'TotalJurisdictionFee',
				type      : 'total',
				label     : 'Total Jurisdiction Fees',
				amountDue : TotalJurisdictionFee,
			});
			returnData.push({
				rowId     : 'RKPayFee',
				type      : 'total',
				label     : 'RKPay Fees',
				amountDue : RKPayFee,
			});
			returnData.push({
				rowId     : 'Tax',
				type      : 'total',
				label     : 'Tax',
				amountDue : Tax,
			});
			returnData.push({
				rowId     : 'Total',
				type      : 'total',
				label     : 'TOTAL',
				amountDue : Total,
			});
		}
		return returnData;
	};

	handleOnClickBack = (event) => {
		event.preventDefault();

		const { history, search, push } = this.props;
		const { paid } = queryString.parse(search);

		if (paid) push('/payments/list/payment');
		else history.goBack();
	}

	render() {
		const {
			data,
			totalReceipt,
			paidOn,
			transactionId,
		} = this.state;
		const { loading, downloadReceiptPDF } = this.props;
		return (
			<Fragment>
				<div className="hidden-print">
					<SubNavBar
						backText="Back"
						backButton
						onClickBack={this.handleOnClickBack}
					/>
				</div>
				<div className="margin-top-30 payment-receipt-div">
					<div className="flex margin-bottom-30">
						<i className="rkfm rkfm-receipt font-size-36 padding-top-10 padding-right-20 color-dark" />
						<div className="flex flex-2 flex-direction-column">
							<div className="flex flex-2">
								<div className="flex">
									<span className="font-size-36 font-light color-dark padding-bottom-10 font-light text-capitalize">Your Receipt</span>
									<div className="padding-top-17 padding-left-20">
										<span className="font-size-10 label label-success">PAID</span>
									</div>
								</div>
							</div>
							<span className="font-size-20 font-light color-dark padding-bottom-10">{ utils.currencyFormatter(totalReceipt) }</span>
							<span className="font-size-20 font-light color-dark padding-bottom-10">
								Paid on:
								{' '}
								<span className="font-size-20 font-light color-gray-cloud-burst">{ paidOn }</span>
							</span>
							<span className="font-size-20 font-light color-dark padding-bottom-10">
								Transaction ID:
								{' '}
								<span className="font-size-20 font-light color-gray-cloud-burst">{ transactionId }</span>
							</span>
						</div>
						<div className="align-self-center hidden-print">
							<i
								className="rkfm rkfm-printer font-size-24 padding-right-20 text-primary cursor-pointer"
								onClick={() => window.print()}
								onKeyPress={null}
								role="button"
								tabIndex={0}
								alt="print invoice"
							/>
							<i
								className="rkf rkf-pdf font-size-24 text-primary cursor-pointer"
								onClick={() => downloadReceiptPDF()}
								onKeyPress={null}
								role="button"
								tabIndex={0}
								alt="download invoice PDF"
							/>
						</div>
					</div>
					{data.length > 0 && (
						<PaymentReceiptTable
							data={data}
							loading={loading}
						/>
					)}
				</div>
			</Fragment>
		);
	}
}

const mapStateToProps = ({
	router : {
		location: { search },
	},
	payments : {
		receipt,
		loading,
	}, app: { user: { TimeZoneId } },
}) => ({
	search,
	receipt,
	TimeZoneId,
	loading : loading.receipt,
});

const mapDispatchToProps = (dispatch) => ({
	downloadReceiptPDF : bindActionCreators(thunks, dispatch).downloadReceiptPDF,
	getReceiptDetails  : bindActionCreators(thunks, dispatch).getReceiptDetails,
	push               : bindActionCreators(pushAction, dispatch),
});

PaymentReceipt.propTypes = {
	downloadReceiptPDF : PropTypes.func.isRequired,
	getReceiptDetails  : PropTypes.func.isRequired,
	history            : PropTypes.object.isRequired,
	loading            : PropTypes.bool,
	push               : PropTypes.func.isRequired,
	receipt            : PropTypes.object,
	search             : PropTypes.string,
	match              : PropTypes.object.isRequired,
	TimeZoneId         : PropTypes.oneOfType([
		PropTypes.number,
		PropTypes.string,
	]),
};

PaymentReceipt.defaultProps = {
	loading    : false,
	receipt    : {},
	search     : '',
	TimeZoneId : '',
};

export default connect(mapStateToProps, mapDispatchToProps)(PaymentReceipt);
